import Blue from '~/core'

new Blue({
  name: 'Accordion',
  selector: '.accordion',
  setup(accordion) {
    const items = [...accordion.querySelectorAll('.accordion__item')]
    const relations = []

    items.forEach((container) => {
      let trigger = container.querySelector('.accordion__trigger')
      let content = container.querySelector('.accordion__content')
      let config = {
        container,
        trigger,
        content,
        relations,
        externalEvents: true,
      }
      let acc = new this.$toggle(config)
      relations.push(acc)

      this.$addEvents(trigger, 'click.stop.prevent enter.stop.prevent', () => {
        /*if (trigger.hasAttribute('data-active')) return;*/
        acc.toggle()
      })
    })

    relations[0].toggle()
  },
})
